<template>
  <v-container fluid tag="section" class="pa-0">
    <v-card class="my-0" elevation='0'>
      <v-tabs v-model="tab" v-bind='$attrs'>
        <v-tab>合同详情</v-tab>
        <v-tab>客户详情</v-tab>
        <v-tab>回款详情</v-tab>
        <v-tab>应收详情</v-tab>
        <v-tab>发票详情</v-tab>
        <v-tab>退款详情</v-tab>
        <v-tab v-for="(rel, idx) in item.relationContractInfos" :key="idx" v-if="item.serialNumber !== rel.serialNumber">
          关联({{rel.serialNumber.substring(rel.serialNumber.lastIndexOf('.')+2,rel.serialNumber.length)}})
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <detail-view mini :item='item' lazy></detail-view>
        </v-tab-item>
        <v-tab-item>
          <customer-detail mini :item='item.customer' lazy></customer-detail>
        </v-tab-item>
        <v-tab-item>
          <returned-view mini outlined :sur-refund-price='item.surplusRefundMoney' :all-price='item.signPrice' :item='item.returnedMoneys'></returned-view>
        </v-tab-item>
        <v-tab-item>
          <collect-view mini outlined :contractId='item.id' :item='item.collectMoneys'></collect-view>
        </v-tab-item>
        <v-tab-item>
          <invoice-detail mini show-mail :all-price='item.signPrice' :item='item.invoiceInfos'></invoice-detail>
        </v-tab-item>
        <v-tab-item>
          <refund-view :item='item.refundInfos'></refund-view>
        </v-tab-item>
          <v-tab-item v-for="(rel, idx) in item.relationContractInfos" :key="idx" v-if="item.serialNumber !== rel.serialNumber">
          <detail-view mini :item='rel' lazy></detail-view>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
 import ReturnedView from '@/views/pages/mobile/contract/returned/components/Detail.vue'
  import CollectView from '@/views/pages/mobile/contract/collect/components/Detail.vue'
  import InvoiceDetail from '@/views/pages/mobile/contract/invoice/components/Detail.vue'
  import RefundView from '@/views/pages/mobile/contract/refund/components/Detail.vue'
  import CustomerDetail from '@/views/pages/mobile/customer/components/Detail.vue'
  import DetailView from './components/Detail.vue'

  export default {
    name: 'ContractDetailIndex',
    components: {
      DetailView,
      ReturnedView,
      CollectView,
      RefundView,
      CustomerDetail,
      InvoiceDetail
    },
    props: {
      item: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        tab: 0
      }
    }
  }
</script>

<style>
</style>
